export const PRODUCTION_HOSTNAMES = [
  'rapidlite.rapidsos.com',
  'rapidsosportal.com',
] as const;

export const GSPX_TRACKING_IDS = {
  prod: 'AP-PEXDVMYJXIFL-2',
  staging: 'AP-PEXDVMYJXIFL-2-2', //staging and sandbox
  qa: 'AP-PEXDVMYJXIFL-2-3',
  dev: 'AP-PEXDVMYJXIFL-2-4', // This is the key for dev
} as const;

export const JURISDICTION_VIEW = 'jurisdiction_view_0';

// Export types for better TypeScript integration
export type GSPXTrackingID = keyof typeof GSPX_TRACKING_IDS;
export type ProductionHostname = (typeof PRODUCTION_HOSTNAMES)[number];
